/* eslint-disable react/sort-comp */
import * as React from 'react';

export type State = {
  log?: LogJson;
};

export type LogJson = {
  hash: string;
  message: string;
  stamp: number;
}[];

export default class DevLogExplorer extends React.Component<{}, {}> {
  state: State = {};
  componentDidMount() {
    fetch('/static/dev-history/git-log.json')
      .then(response => response.json())
      .then(log => this.setState({log}));
  }
  releases() {
    if (!this.state.log) return [];
    const res: {
      [version: string]: {
        version: string;
        prodDirUrl: string;
        devDirUrl: string;
        releaseStamp: number;
        commits: LogJson;
      };
    } = {};
    let commits: LogJson = [];
    this.state.log.forEach(commit => {
      commits.push(commit);
      const {stamp, message, hash} = commit;
      if (/^[0-9]+.[0-9]+.[0-9]+$/.test(message)) {
        const prodHash = hash.slice(0, 5);
        const devHash = hash.slice(5, 12);
        const version = message;
        const [majorV, minorV] = version.split('.');
        const prodDirUrl = `https://yastatic.net/s3/milab/2021/old-words/front-v${majorV}/builds/v${minorV.padStart(
          3,
          '0',
        )}-${prodHash}`;
        const devDirUrl = `${prodDirUrl}/dev-${devHash}`;
        res[version] = {
          version: message,
          prodDirUrl,
          devDirUrl,
          releaseStamp: stamp,
          commits,
        };
        commits = [];
      }
    });
    return res;
  }
  render() {
    if (!this.state.log) return <div>Загрузка логов...</div>;
    return (
      <div>
        {Object.entries(this.releases())
          .reverse()
          .map(([version, {devDirUrl, prodDirUrl, releaseStamp, commits}]) => (
            <div key={version}>
              <div>{version}</div>
              <div>
                <a href={`${prodDirUrl}/index.html`}>{prodDirUrl}</a>
              </div>
              <div>
                <a href={`${devDirUrl}/index.html`}>{devDirUrl}</a>
              </div>
              <div>
                {new Date(releaseStamp * 1000)
                  .toISOString()
                  .replace('T', ' ')
                  .replace('.000', '')
                  .replace('Z', '')}
              </div>
              <div style={{whiteSpace: 'pre', background: 'lightgray', fontSize: '0.8em'}}>
                {commits.map(c => JSON.stringify(c)).join('\n')}
              </div>
            </div>
          ))}
      </div>
    );
  }
}
